import * as mutationTypes from "../store/mutation-types";
import userNotificationsHelper from "./userNotificationsHelper";
import ProductSelection from "../domains2/orders/ProductSelection";
import routeMapper from "../router/routeMapper";
import { DeliveryMethodsEnum } from "../domains2/libraries/DeliveryMethods";
import { Capacitor } from "@capacitor/core";
import { FCM } from "@capacitor-community/fcm";
import appConfig from "../appconfig";

export const handleOnPushNotificationTap  = async (router, store, obj) => {
	const {postOrderDiscount} = obj.notification.data;
	if (postOrderDiscount) {
		const {shopId, deliveryChoice, productId, voucherCode} = JSON.parse(postOrderDiscount);
		if (!shopId || !Object.values(DeliveryMethodsEnum).includes(deliveryChoice) || !productId || !voucherCode) {
			return;
		}
		await store.dispatch(mutationTypes.ADD_PRODUCT_SELECTION_TO_CART, {
			...ProductSelection.createFromProduct(store.getters.productCatalog.getProduct(productId)),
			quantity: 1
		});
		router.push({
			name: routeMapper.routeNames.checkoutCart,
			params: {
				voucherCode
			}
		});
	} else {
		userNotificationsHelper.createUserNotificationOnPushNotificationTap(router, obj);
	}
};

export const saveTokenDuringRegistration = async (token, store) => {
	if (appConfig.isBM100()) {
		let fcmToken = token;
		if (Capacitor.getPlatform() === "ios") {
			fcmToken = (await FCM.getToken()).token;
		}
		store.commit(mutationTypes.FCM_TOKEN, fcmToken);
	}
};